module.exports = __webpack_public_path__ + "static/media/4.5b9cd157.jpg";